var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 74,
    viewBox: "0 0 58 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 0H8.16667C3.675 0 0 3.675 0 8.16667V73.5L28.5833 61.25L57.1667 73.5V8.16667C57.1667 3.675 53.4917 0 49 0ZM49 61.25L28.5833 52.3483L8.16667 61.25V8.16667H49V61.25Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.084 25.115L36.719 20.75L29.084 28.385L21.449 20.75L17.084 25.115L24.719 32.75L17.084 40.385L21.449 44.75L29.084 37.115L36.719 44.75L41.084 40.385L33.449 32.75L41.084 25.115Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4984ec5c213f468623e905b1a1e5aba9.svg";
export { ForwardRef as ReactComponent };